<template>
  <div>
    <ui-card
      :is-loading="isLoading"
      class="overview-card h-100"
    >
      <div class="card-header overview-card__header mb-4 pb-2">
        <ui-icon name="overdue-payouts" size="32px" />
        <h4 class="card-title overview-card__title">
          Overdue distributions
        </h4>
      </div>
      <template v-if="previewDistributions.length">
        <div
          v-for="item in previewDistributions"
          :key="item.workplace.id"
          class="d-flex justify-content-between mt-3"
        >
          <router-link
            :to="{ name: 'location-view', params: { locationId: item.workplace.id }}"
            class="card-label overview-card__label"
          >
            {{ item.workplace.name }}
          </router-link>
          <div class="card-value pl-2 ml-auto">
            {{ item.amount.amount | money(item.amount.currency) }}
          </div>
          <stats-overdue-info
            :days="item.overdueDays"
            :since="item.firstNoneDistributedDate"
            class="ml-2"
          />
        </div>
      </template>
      <span v-else class="text-gray">
        {{ $t('noData') }}
      </span>

      <template #footer>
        <stats-overdue-distributions-modal
          v-if="items.length > previewCount"
          :distributions="items"
        >
          <template #activator="{ open }">
            <ui-button
              link
              type="primary"
              @click="open"
            >
              {{ $t('form.buttons.viewAll') }}
            </ui-button>
          </template>
        </stats-overdue-distributions-modal>
      </template>
    </ui-card>
  </div>
</template>

<script>
import api from '@/api';
import StatsOverdueDistributionsModal from '@/components/Stats/StatsOverdueDistributionsModal.vue';
import StatsOverdueInfo from '@/components/Stats/StatsOverdueInfo.vue';
import StatsMixin from './StatsMixin';

export default {

  mixins: [
    StatsMixin,
  ],

  components: {
    StatsOverdueDistributionsModal,
    StatsOverdueInfo,
  },

  data: () => ({
    items: [],
    previewCount: 5,
  }),

  computed: {
    previewDistributions() {
      return this.items.slice(0, this.previewCount);
    },
  },

  methods: {
    async load() {
      const { data } = await api.locations.getOverdueDistributions({
        salesId: this.staffId,
      });

      if (data) {
        this.items = data;
      }
    },
  },
};
</script>
